const Colors = {
  main: 'rgb(61, 80, 183)',
  purple: 'rgb(176, 0, 177)',
  red: 'rgb(202, 46, 46)',
  sky: 'rgb(141, 189, 234)',
  lred: 'rgb(220, 126, 117)',
};

module.exports = Colors;
